'use client';

import React, { useState, useEffect } from 'react';

interface MediaQueryProps {
  query: string;
}

export default function useMediaQuery({ query }: MediaQueryProps) {
  const [matches, setMatches] = useState<boolean>(false);

  const handleMediaChange = (e: MediaQueryListEvent) => {
    setMatches(e.matches);
  };

  useEffect(() => {
    const mediaQuery = window.matchMedia(query);

    // 初始化
    if (mediaQuery.matches !== matches) {
      setMatches(mediaQuery.matches);
    }

    mediaQuery.addEventListener('change', handleMediaChange);
    return () => {
      mediaQuery.removeEventListener('change', handleMediaChange);
    };
  }, [query]);

  return { matches };
}
